import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVerticalAlignmentLeft: React.FC<CentralIconBaseProps> = (
  props,
) => {
  return (
    <CentralIconBase {...props} ariaLabel="vertical-alignment-left">
      <path
        d="M4 4V20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M20 7H8V10H20V7Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M16 14H8V17H16V14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconVerticalAlignmentLeft;
